<template>
  <div>
    <!-- Step Indicator -->
    <div class="stepper-container" v-if="showStepper">
      <div class="step" v-bind:class="{ selected: currentStep >= 0 }"></div>
      <div
        class="step"
        v-show="isDonation"
        v-bind:class="{ selected: currentStep >= 1 }"
      ></div>
      <div class="step" v-bind:class="{ selected: currentStep >= 2 }"></div>
    </div>

    <!-- Steps -->
    <LeafReliefDetails
      :petitionSelector="petitionSelector"
      :donationSelector="donationSelector"
      :programName="programName"
      :datalayerName="datalayerName"
      :duplicateEmailMessage="duplicateEmailMessage"
      :sendToIve="sendToIve"
      :iveSupplier="iveSupplier"
      :iveSource="iveSource"
      v-on:next="next(0)"
      v-if="currentStep === 0"
    ></LeafReliefDetails>
    <Payment
      :datalayerName="datalayerName"
      v-on:next="next(1)"
      v-if="currentStep === 1"
    ></Payment>
    <!-- V-show because the "Get social" need to be in the DOM to be loaded -->
    <ThankYou
      :thankYouText="thankYouText"
      :getSocialText="getSocialText"
      v-on:next="next(2)"
      v-show="currentStep === 2"
    ></ThankYou>
  </div>
</template>

<script>
import LeafReliefDetails from "./Details.vue"; // Step 1
import Payment from "./Payment.vue"; // Step 2
import ThankYou from "./ThankYou.vue"; // Step 3

import { mapGetters } from "vuex";
import { getParameterByName } from "../../helpers";

export default {
  name: "Stepper",
  components: {
    LeafReliefDetails,
    Payment,
    ThankYou,
  },

  data() {
    return {
      isRg: false,
    };
  },
  computed: {
    ...mapGetters(["isDonation"]),
    showStepper() {
      return this.currentStep > 0 && this.isDonation;
    },
    currentStep: {
      get() {
        return this.$store.state.leafRelief.currentStep;
      },
      set(value) {
        this.$store.commit("updateLeafRelief", { field: "currentStep", value });
      },
    },
  },

  props: {
    programName: {
      type: String,
    },
    datalayerName: {
      type: String,
    },

    // IVE
    sendToIve: {
      type: Boolean,
    },
    iveSupplier: {
      type: String,
    },
    iveSource: {
      type: String,
    },

    // Selectors
    petitionSelector: {
      type: String,
    },
    donationSelector: {
      type: String,
    },

    duplicateEmailMessage: {
      type: String,
    },
    petitionHandle: {
      type: String,
    },

    // Thank You
    thankYouText: {
      type: String,
    },
    getSocialText: {
      type: String,
    },

    // Thank You Popup
    raRgId: {
      type: String,
    },
    raSgId: {
      type: String,
    },
    edoId: {
      type: String,
    },
  },

  created() {
    const status = getParameterByName("s");
    if (!!status && status === "rg") {
      this.isRg = true;
    }
  },

  methods: {
    next(oldStep) {
      if (this.isDonation && oldStep === 0) {
        // For a donation, step 2 is payment
        this.currentStep = 1;

        // Move to top of the form
        const el = document.getElementById("leaf-relief");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Original plan, showing a 3rd step with a thank you message
        // Then is changed to show a popuop with different mesages depending on the journey of the user

        // Set session flag when donation complete to prevent exit popup from displaying
        window.sessionStorage.setItem("leafReliefActioned", "true");

        // Amplitude
        this.$store.dispatch("logLeafComplete");

        // this.showThankYouStep();
        this.openThankYouPopup();
      }
    },

    showThankYouStep() {
      // 3rd step - For petition or after donation step 2, show thank you
      this.currentStep = 2;

      // Move to top of the form
      const el = document.getElementById("leaf-relief");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },

    openThankYouPopup() {
      // Show Popup
      // Open thank you popup
      // Fetch the content then display the popup
      const id = this.mapThankYouContent();

      if (!!id) {
        this.$store
          .dispatch("getContentMessageById", id)
          .then((response) => {
            if (!!response) {
              const title = response.description;
              const content = response.content;

              this.$store.commit("setPopupContent", {
                component: "step-up",
                componentparams: {
                  id,
                  title,
                  content,
                },
              });
              this.$store.commit("openStepUpPopup", true);

              this.$store.dispatch("logStepUp", id);

              // Once the popup is displayed, return to the beginning
              setTimeout(() => {
                this.currentStep = 0;
              }, 200);
            } else {
              // if no content is returned
              this.showThankYouStep();
            }
          })
          .catch((err) => {
            console.error(err);
            this.showThankYouStep();
          });
      } else {
        // If no ID is set
        this.showThankYouStep();
      }
    },

    mapThankYouContent() {
      // Check for query params for step up override
      const override = getParameterByName("stepup");
      if (override) {
        return override;
      }

      if (this.isDonation) {
        return this.edoId;
      } else {
        if (this.isRg) {
          return this.raSgId;
        } else {
          return this.raRgId;
        }
      }
    },
  },
};
</script>

<style scoped>
.stepper-container {
  padding: var(--lrPadding);
  margin-bottom: 0;
}

.stepper-container .step {
  height: 8px;
  border: 2px solid var(--wwfRegenerateAustralia);
}

.stepper-container .step.selected {
  background-color: var(--wwfRegenerateAustralia);
}
</style>


// WEBPACK FOOTER //
// Stepper.vue?7d12692d